import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M18 4a1 1 0 0 0-1.351-.936l-8 3A1 1 0 0 0 8 7v9H7a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-7.307l6-2.25V14h-1a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-1q0-.15-.021-.293.021-.1.021-.207z"
    }
  )
);
var SvgMusicFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MusicFilled_default = SvgMusicFilled;

export { MusicFilled_default as default };
